import IVersion from '../IVersion';

// The average hourly earnings (KTA, €/h) a new position starts with; the user can change it
export const DEFAULT_AVERAGE_HOURLY_EARNINGS = '25';

const getDefaultVersion = (): IVersion => ({
  averageHourlyEarnings: DEFAULT_AVERAGE_HOURLY_EARNINGS,
  id: 0,
  installerCount: '1',
  installations: [],
  offerText: '',
  isPrimary: true,
  name: '',
  showInOfferPdf: true,
  subproducts: [],
  calculationReviews: [],
});

export default getDefaultVersion;
